import api from "./api";

const BASE = "/api/settings/role";

const getAll = () => api.get(`${BASE}/getAll`);

/** Roles list for the management UI (counts, branch scope, timestamps). */
const getManageList = () => api.get(`${BASE}/manage`);

/** Aggregate stats for the Roles page cards. */
const getStats = () => api.get(`${BASE}/stats`);

/** Role detail incl. attached policies and resolved permission links. */
const getDetail = (id) => api.get(`${BASE}/detail/${id}`);

/** Replace the set of policies attached to a role. */
const setPolicies = (roleId, policyIds) => api.post(`${BASE}/setPolicies`, { roleId, policyIds });

const create = (payload) => api.post(`${BASE}/create`, payload);

const update = (id, payload) => api.post(`${BASE}/update/${id}`, payload);

const remove = (id) => api.post(`${BASE}/remove/${id}`);

const RoleService = {
  getAll,
  getManageList,
  getStats,
  getDetail,
  setPolicies,
  create,
  update,
  remove,
};

export default RoleService;
